/**
 * our internal 4 letter code, similar to ISO 639-1 but no dashes as GraphQL enums cannot have dashes
 */
export enum SupportedLocalesEnum {
  enUs = 'enUs',
  enGb = 'enGb',
  esEs = 'esEs',
  frFr = 'frFr',
  itIt = 'itIt',
  deDe = 'deDe',
  ptBr = 'ptBr',
  ptPt = 'ptPt',
  zhHans = 'zhHans',
  zhHant = 'zhHant',
  viVn = 'viVn',
  pseudo = 'pseudo'
}

export enum SupportedCamelCasedLocalesEnum {
  enUs = 'en-us',
  enGb = 'en-gb',
  esEs = 'es-es',
  frFr = 'fr-fr',
  itIt = 'it-tt',
  deDe = 'de-de',
  ptBr = 'pt-br',
  ptPt = 'pt-pt',
  zhHans = 'zh-hans',
  zhHant = 'zn-hant',
  viVn = 'vi-vn',
  pseudo = 'en-us'
}

export enum SupportedSCORMLocalesEnum {
  enUs = 'en-us',
  enGb = 'en-gb',
  esEs = 'es-es',
  frFr = 'fr-fr',
  itIt = 'it-it',
  deDe = 'de-de',
  ptBr = 'pt-br',
  zhHans = 'zh-cn',
  pseudo = 'en-us'
}
